/* @jsx h */
import { h, Component, render } from 'preact';
import Icon from './icon';

class CartFlyout extends Component {

	constructor() {
		super();

		this.state = {
			open: false,
			cart: {},
			showupdate: false,
			showsuccess: false,
			scrollable: false,
			offset: 0,
			maxReached: false
		};

		this.cartupdated = this.cartupdated.bind(this);
		this.cartadded = this.cartadded.bind(this);
		this.onPrev = this.onPrev.bind(this);
		this.onNext = this.onNext.bind(this);
		this.setHeight = this.setHeight.bind(this);
		this.onMaxScrollReached = this.onMaxScrollReached.bind(this);
		this.onDirectInputClick = this.onDirectInputClick.bind(this);
		this.onDirectInputChange = this.onDirectInputChange.bind(this);
	}

	cartupdated() {
		let cart = window.Viollier.Cart.cart;

		if (Object.prototype.toString.call(cart.entries) === '[object Array]') {
			cart.entries.reverse();
		} else {
			cart.entries = [];
		}

		this.setState({
			cart: cart
		});
	}

	cartadded() {
		this.setState({
			showupdate: new Date().getTime()
		});

		setTimeout(function() {
			var now = new Date().getTime();

			if (this.state.showupdate !== false && now - this.state.showupdate > 1500) {
				this.setState({
					showupdate: false
				});
			}
		}.bind(this), 2000);
	}

	componentDidMount() {
		jQuery(document).on('cartupdated', this.cartupdated);
		jQuery(document).on('cartadded', this.cartadded);

		window.Viollier.Cart.getCart();

		if (window.location.hash === '#cart-direct-order') {
			setTimeout(function() {
				jQuery('#cart-direct-order .code').focus();
			}, 100);
		}

		this.setHeight();
		jQuery(window).on('resize', this.setHeight);
	}

	componentWillUnmount() {
		jQuery(document).off('cartupdated');
		jQuery(document).off('cartadded');
		jQuery(window).off('resize');
	}

	setHeight() {
		let windowHeight = jQuery(window).height();

		if (this.state.scrollable && jQuery(window).width() < 768) {
            // Hack to fix flickering cart when resizing window
            // jQuery('[data-init="cart-icon"]').click();
		} else {
			this.setState({
				scrollable: (windowHeight < 1100)
			});
		}
	}

	onPrev(e) {
		e.stopPropagation();

		if (this.state.offset === 0) {
			return;
		}

		this.setState({
			offset: this.state.offset - 100,
			maxReached: false
		});
	}

	onNext(e) {
		e.stopPropagation();

		if (!this.state.maxReached) {
			this.setState({
				offset: this.state.offset + 100
			});
		}
	}

	onMaxScrollReached() {
		this.setState({
			maxReached: true
		});
	}

	onRemove(entryNumber) {
		window.Viollier.Cart.remove(entryNumber, function() {
			window.Viollier.Cart.getCart();
		});
		return false;
	}

	onCartClick(e) {
		e.preventDefault();
		window.location = jQuery('.block-viollier-cart-block [data-init="cart-icon"]').attr('data-cart-page-url');
	}

	onSaveClick() {
		jQuery.featherlight(`
			<div class="save-cart-to-list">
				<div class="vio-h3">${Drupal.t('Please choose a name for your list')}</div>
				<p>${Drupal.t('All products from the current cart will be saved on this list. You will be able to access the list from your account.')}</p>
				<form onSubmit="window.Viollier.Cart.saveList(event)">
					<input type="text" name="name" placeholder="${Drupal.t('Name')}" class="form-text" />
					<button type="submit" class="button js-form-submit form-submit">${Drupal.t('Save list')}</button>
				</form>
			<div>
		`, {});
	}

	onDirectOrderClick() {
		window.location = jQuery('.block-viollier-cart-block [data-init="cart-icon"]').attr('data-cart-page-url') + '#cart-direct-order';
		jQuery('#cart-direct-order .code').focus();
	}

	onDirectInputClick(e) {
		e.stopPropagation();
	}

	onDirectInputChange(e) {
		if (e.keyCode === 13) {
			let value = jQuery.trim(e.target.value.replace(/\D/g, ''));

			if (value !== '') {
				window.location = jQuery('.block-viollier-cart-block [data-init="cart-icon"]').attr('data-cart-page-url') + '#cart-direct-order-' + value;
			}
		}
	}

	render(props, state) {
		if (state.open === false && state.showupdate !== false) {
			return (
				<div class="viollier-cart-wrapper is-opened">
					<h2 class="cart-title">{Drupal.t('The article was successfully added to your cart!')}</h2>
				</div>
			);
		} else {
			if (typeof state.cart.totalPrice === 'undefined') {
				return <div />;
			} else if (typeof state.cart.entries !== 'undefined') {
				const cartCnt = window.Viollier.Cart.getCartCnt();
				let recentCnt = cartCnt;

				if (recentCnt > 3) {
					recentCnt = 3;
				}

				return (
					<div class={'viollier-cart-wrapper ' + (state.open ? 'is-opened' : '')}>
						<button class="cart-icon-close" data-control="cart-icon-close">
							<Icon id="close" />
						</button>
						<div class="cart-entries-container">
							{state.cart.entries.length > 0 ?
								<CartEntries onMaxScrollReached={this.onMaxScrollReached} entries={state.cart.entries} onRemove={this.onRemove} offset={state.offset} /> :
								<div class="empty-cart">{Drupal.t('Your cart is empty')}</div>
							}
						</div>
						<div class="cart-actions">
							<input class="input" onClick={this.onDirectInputClick} onKeyUp={this.onDirectInputChange} type="text" placeholder={Drupal.t('Enter article number directly')} />
							<button class="main" onClick={() => this.onCartClick(event)}>{Drupal.t('Go to cart')}</button>
						</div>
					</div>
				);
			} else {
				return (
					<div class={'viollier-cart-wrapper ' + (state.open ? 'is-opened' : '')}>
						<h2 class="cart-title">{Drupal.t('Your cart is empty')}</h2>
						<div class="cart-actions">
							<input class="input" onClick={this.onDirectInputClick} onKeyUp={this.onDirectInputChange} type="text" placeholder={Drupal.t('Enter article number directly')} />
						</div>
					</div>
				);
			}

		}
	}
}

class CartEntries extends Component {
	componentDidUpdate() {
		this.base.scrollTop = this.props.offset;

		if (this.base.scrollTop === (this.base.scrollHeight - this.base.offsetHeight) && this.base.scrollTop > 0) {
			this.props.onMaxScrollReached();
		}
	}
	render(props) {
		return (
			<ul class='viollier-cart-entries'>
				{props.entries.map((entry) =>
					<CartEntry {...entry} onRemove={props.onRemove} key={entry.product.code} />
				)}
			</ul>
		);
	}
}

class CartEntry extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
		this.onUrlClick = this.onUrlClick.bind(this);
	}

	onClick(e) {
		e.stopPropagation();
		e.preventDefault();

		if (this.removeFlag) {
			return;
		}

		this.removeFlag = true;

		window.Viollier.Cart.remove(this.props.entryNumber, function() {
			window.Viollier.Cart.getCart(function() {
				this.removeFlag = false;
			});
		});
	}

	onUrlClick() {
		window.location.href = this.props.product.url;
	}

	render(props) {
		let unitCode = props.unit.code,
			unitInfo = props.product.sales_units.filter(function(obj) {
				return obj.code === unitCode;
			}),
			quantity;

		if (unitInfo.length && typeof unitInfo[0].name !== 'undefined') {
			quantity = unitInfo[0].name;
		} else {
			quantity = '';
		}

		return (
			<li class="product" key={props.product.code}>
				<div class="product-image-container" onClick={this.onUrlClick}>
					<img class="product-image" src={props.product.images[0].url} />
					{props.product.discounted ? <svg>
						<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/themes/custom/estatico/assets/media/sprite.svg#discount"></use>
					</svg> : null}
				</div>
				<div class="product-meta">
					<div class="product-name" onClick={this.onUrlClick}>{props.product.name}</div>
					<div class="product-quantity">{props.quantity} {quantity}</div>
					<div class="product-sku">{Drupal.t('Art.-No.')} {props.product.code}</div>
				</div>
				<div class="product-actions">
					<button class="product-remove" onClick={this.onClick}>
						<Icon id="basket" />
					</button>
				</div>
			</li>
		);
	}
}

(function ($, once) {
	'use strict';
	Drupal.behaviors.carticon = {
		attach: function() {
			var $quantityEl,
				$cartBlock = $('.block-viollier-cart-block');

			once('carticon', $cartBlock === document ? 'html' : $cartBlock).forEach(function() {
			//$cartBlock.once('carticon').each(function() {

				if ($cartBlock.length > 0 && $cartBlock.find('.quantity').length === 0) {
					$quantityEl = $('<span />').addClass('quantity').addClass('hidden');
					$quantityEl.appendTo($cartBlock.find('[data-init="cart-icon"]'));
				}

				render(
					<CartFlyout />,
					$cartBlock[0]
				);

				$cartBlock.on('click', function() {
					$(this).toggleClass('is-opened');
				});
			});
		}
	};

}(jQuery, once));
